.main {
	position: absolute;
	top: var(--jpo-common-base-spacing);
}
